// CLARTEXT SPRACHE – Rumänische Mitarbeiter-UI (AP-LANG-RO, Juni 2026).
// Echte rumänische Übersetzung der Monteur-App-UI (KEIN Re-Export mehr von de.js).
// Schlüssel-IDENTISCH zu de.js; fehlende Schlüssel fallen über createT auf Deutsch
// zurück. Weltinhalte (Welt-Titel, Fragen, Antwortoptionen, GBU-/BA-Texte) sind
// Daten und kommen über den Read-Resolver (`display`), NICHT aus dieser Datei.
// Rumänische Sonderzeichen (ă â î ș ț) sind UTF-8 kodiert.
const ro = {
  // Gemeinsame
  "common.loading": "Se încarcă…",

  // PIN-Login (/monteur/login)
  "login.eyebrow": "Autentificare",
  "login.title": "PIN-ul tău",
  "login.subtitle": "Codul firmei + PIN-ul din 4 cifre de la superiorul tău.",
  "login.companyCodeLabel": "Codul firmei",
  "login.companyCodePlaceholder": "de ex. LUMPE",
  "login.submitting": "Se conectează…",
  "login.backAria": "Înapoi la autentificare",
  "login.errorNoCode": "Introdu mai întâi codul firmei.",
  "login.errorUnknown": "Firmă sau PIN necunoscut.",

  // Aufgabenliste (/monteur)
  "tasks.companyFallback": "Firma ta",
  "tasks.portalSubtitle": "Portal de instruire",
  "tasks.loggedInAs": "Autentificat ca",
  "tasks.heading": "Sarcinile tale",
  "tasks.openCount": "{count} deschise",
  "tasks.emptyToday": "Nicio sarcină deschisă astăzi.",
  "tasks.newBanner": "Aveți {count} instruiri noi de la ultima vizită.",
  "tasks.newBadge": "Nou",
  "tasks.newBannerDismissAria": "Închide notificarea",
  "tasks.backAria": "Înapoi la prezentare",
  "home.tasksTitle": "Instruiri",
  "home.searchTitle": "Ghid de referință",
  "home.searchSubtitle": "Găsiți rapid informații de siguranță",
  "home.hspTitle": "Plan de protecție a pielii",
  "home.hspSubtitle": "Protecția pielii și alegerea mănușilor",
  "home.driverTitle": "Verificarea permisului de conducere",
  "home.driverOpen": "Vă rugăm să trimiteți permisul",
  "home.driverSubmitted": "În așteptarea verificării de către firmă",
  "home.driverUpToDate": "Valabil în prezent",
  "home.settingsTitle": "Setări",
  "home.settingsSubtitle": "Gestionați e-mailul și limba",
  "home.comingSoon": "În curând",
  "home.newBubbleAria": "{count} instruiri noi",
  "settings.profileTitle": "Profil",
  "settings.profileHint": "Numele și firma sunt gestionate de firmă.",
  "settings.emailTitle": "E-mail pentru notificări",
  "settings.emailPurpose": "Folosit exclusiv pentru a vă informa despre instruiri noi.",
  "settings.emailPlaceholder": "nume@exemplu.ro",
  "settings.emailSave": "Salvează",
  "settings.emailSaved": "Salvat",
  "settings.emailInvalid": "Introduceți o adresă de e-mail validă.",
  "settings.emailRemoveHint": "Goliți câmpul și salvați pentru a vă dezabona.",
  "settings.saveError": "Salvarea a eșuat. Încercați din nou.",
  "settings.privacyLink": "Politica de confidențialitate",
  "settings.consentLabel": "Doresc să fiu informat prin e-mail despre noile instructaje.",
  "settings.languageTitle": "Limba",
  "settings.langNotBooked": "Limbile gri nu au fost încă rezervate de firma dumneavoastră. Vorbiți cu șeful dacă doriți să folosiți una dintre ele.",
  "tasks.quickLookup": "Căutare rapidă",
  "tasks.doneHeading": "Deja finalizate",
  "tasks.dueLabel": "Scadent",
  "tasks.doneAtLabel": "Finalizat la",
  "tasks.logoutAria": "Deconectare",

  // Aufgabendetail (/monteur/aufgabe/:id)
  "aufgabe.notFound": "Sarcina nu a fost găsită.",
  "aufgabe.wrongOne":
    "Un răspuns nu a fost corect. Te rugăm să răspunzi din nou.",
  "aufgabe.wrongMany":
    "{count} răspunsuri nu au fost corecte. Te rugăm să răspunzi din nou.",
  "aufgabe.saveFailed": "Salvarea a eșuat. Te rugăm să încerci din nou.",
  "aufgabe.doneTitle": "Gata!",
  "aufgabe.doneBody":
    "Instruirea „{title}” este finalizată. Înregistrarea ta a fost creată automat și este păstrată în dosarul de audit al firmei.",
  "aufgabe.backToTasks": "Înapoi la sarcinile mele",
  "aufgabe.stepContent": "Conținut",
  "aufgabe.stepQuestion": "Întrebarea {current} din {total}",
  "aufgabe.backShort": "Sarcini",
  "aufgabe.readCalm": "Te rugăm să citești cu atenție.",
  "aufgabe.questionsFollow": "Apoi urmează {count} întrebări scurte de verificare.",
  "aufgabe.questionLabel": "Întrebare de verificare {current} / {total}",
  "aufgabe.wrongAgain":
    "Acest răspuns nu a fost corect la încercarea anterioară. Te rugăm să alegi din nou.",
  "aufgabe.prev": "Înapoi",
  "aufgabe.saving": "Se salvează…",
  "aufgabe.finish": "Finalizează instruirea",
  "aufgabe.toQuestions": "Mergi la întrebări",
  "aufgabe.next": "Următorul",

  // Nachschlage-Suche (Komponente MonteurWeltSuche)
  "suche.placeholder": "Caută – de ex. „baterie”, „ochelari”, „scară”…",
  "suche.inputAria": "Caută în documentație",
  "suche.matchIn": "Potrivire în {label}:",
  "suche.empty": "Nicio documentație potrivită găsită.",
  "suche.emptyHint": "Încearcă alt cuvânt, de ex. „EIP” sau „bandaj”.",

  // Welt-Nachschlagewerk (/monteur/welt/:id) – NUR UI-Rahmen/Labels.
  "welt.headerTitle": "Căutare",
  "welt.backAria": "Înapoi",
  "welt.errorNotAvailable": "Această documentație nu este disponibilă momentan.",
  "welt.errorLoad": "Documentația nu a putut fi încărcată.",
  "welt.backToTasks": "Înapoi la sarcinile mele",
  "welt.loading": "Se încarcă documentația…",
  "welt.doctype": "Referință",
  "welt.versionLabel": "Versiune",
  "welt.gbuTitle": "Evaluarea riscurilor",
  "welt.noHazards": "Niciun pericol individual documentat.",
  "welt.residualRisk": "Risc rezidual:",
  "welt.measureTechnical": "Tehnice",
  "welt.measureOrganizational": "Organizatorice",
  "welt.measurePersonal": "Personale",
  "welt.responsible": "Responsabil:",
  "welt.baTitle": "Instrucțiuni de utilizare",
  "welt.baSubtitle": "Conform TRBS / GefStoffV / BetrSichV",
  "welt.mainHazards": "Pericole principale",
  "welt.protectiveMeasures": "Măsuri de protecție și reguli de conduită",
  "welt.emergency": "În caz de urgență",
  "welt.firstAid": "Prim ajutor",
  "welt.disposalHazmat": "Depozitare și eliminare",
  "welt.disposalVehicle": "Parcare",
  "welt.disposalDefault": "Scoatere din uz",
  "welt.instructionTitle": "Instruire",
  "welt.instructionSubtitle": "Conform DGUV V1 §4",
  "welt.visualTitle": "Materiale vizuale de învățare",
  "welt.visualSubtitle":
    "Sprijină înțelegerea – nu modifică niciun conținut, înregistrare sau PDF",
  "welt.questionsTitle": "Întrebări de verificare",
  "welt.questionsSubtitle":
    "{count} întrebări — autoverificare, fără a marca răspunsul corect",
  "welt.maintenanceTitle": "Note de inspecție și întreținere",
  "welt.maintenanceSubtitle": "Conform BetrSichV / UVV",
  "welt.performedBy": "Efectuat de:",
  "welt.recommendedCheck": "Inspecție recomandată de specialist:",
  "welt.recurrenceTitle": "Cicluri de recurență",
  "welt.recurrenceSubtitle": "Per modul – monitorizat automat de sistem",
  "welt.recurrenceUnterweisung": "Instruire",
  "welt.recurrenceGbuReview": "Evaluarea riscurilor – revizuire",
  "welt.recurrenceWartung": "Întreținere / inspecție",
  "welt.recurrence.none": "–",
  "welt.recurrence.einmalig": "O singură dată",
  "welt.recurrence.monatlich": "Lunar",
  "welt.recurrence.vierteljaehrlich": "Trimestrial",
  "welt.recurrence.halbjaehrlich": "Semestrial",
  "welt.recurrence.jaehrlich": "Anual",
  "welt.recurrence.zwei_jahre": "La fiecare 2 ani",

  // Aufgaben-Status (StatusBadge)
  "status.offen": "Deschis",
  "status.erledigt": "Finalizat",
  "status.ueberfaellig": "Restant",

  // Feste Abschnitts-Überschriften (content[].heading). Lookup-Schlüssel bleibt der
  // DEUTSCHE Quell-Heading; nur der WERT ist rumänisch. DB/Beweiskette bleiben deutsch.
  "contentHeading.Worum geht es?": "Despre ce este vorba?",
  "contentHeading.Welche Gefahren bestehen?": "Ce pericole există?",
  "contentHeading.Vor Arbeitsbeginn beachten": "Înainte de începerea lucrului",
  "contentHeading.Während der Arbeit beachten": "În timpul lucrului",
  "contentHeading.Nach der Arbeit beachten": "După terminarea lucrului",

  // UI-/Präsentationslabels der visuellen Lernschicht (VLOs).
  "vlo.safetySymbols.title": "Simboluri de siguranță",
  "vlo.safetySymbols.hint":
    "Aceste simboluri sprijină instruirea. Textul este întotdeauna determinant.",
  "vlo.psaSummary.title": "Rezumat EIP",
  "vlo.hazardMarkers.title": "Marcaje de pericol",
  "vlo.learningFocus.title": "Focus de învățare",
  "vlo.richtigFalsch.title": "Corect și greșit",
  "vlo.richtigFalsch.correct": "Corect",
  "vlo.richtigFalsch.wrong": "Greșit",

  // PRINT.1 (Juni 2026) – etichete afiș (elemente UI ale afișului tipărit).
  "plakat.eyebrow": "Afiș de instruire",
  "plakat.subtitle": "Lucrați în siguranță – cele mai importante reguli pe scurt",
  "plakat.symbols": "Semne de securitate",
  "plakat.hazards": "Pericole",
  "plakat.richtigFalsch": "Corect și greșit",
  "plakat.correct": "Corect",
  "plakat.wrong": "Greșit",
  "plakat.psa": "Echipament individual de protecție (EIP)",
  "plakat.rules": "Cele mai importante reguli",
  "plakat.qrTitle": "Deschideți direct lumea",
  "plakat.qrText": "Scanați codul QR cu telefonul, introduceți PIN-ul – această lume de documentație se deschide imediat.",
  "plakat.footerHint": "Acest afiș sprijină instruirea. Instruirea completă rămâne obligatorie.",
  "plakat.moreInFull": "Mai mult conținut în instruirea completă",

  // AP-PLAKAT-UX (Juni 2026) – subtitluri de grup + paginare.
  "plakat.hazardsSub": "Ce se poate întâmpla?",
  "plakat.correctSub": "Cum se lucrează în siguranță.",
  "plakat.wrongSub": "Cum nu este permis să se lucreze.",
  "plakat.continued": "continuare",
  "plakat.page": "Pagina",
};

const roExtra = {
  "aushang.linkTitle": "Legi și reglementări cu obligație de afișare",
  "aushang.linkSubtitle": "Texte oficiale originale",
  "aushang.pageTitle": "Legi și reglementări cu obligație de afișare",
  "aushang.categoryAllgemein": "Baze legale generale",
  "aushang.categoryDguv": "Reglementări DGUV și reguli tehnice",

  "common.back": "Înapoi",
  "common.notEnabled": "Această secțiune nu este activată pentru firma dumneavoastră.",

  "aushang.kicker": "Obligație de afișare",
  "aushang.intro": "Linkuri către textele oficiale originale. Operatorul întreține lista centralizat; actualizările sunt verificate înainte de publicare.",
  "aushang.loadError": "Lista nu a putut fi încărcată.",
  "aushang.listLoading": "Se încarcă…",
  "aushang.listEmpty": "Momentan nu există intrări — operatorul întreține lista prin consola operatorului.",
  "aushang.categoryEmpty": "Nu există intrări în această categorie.",

  "hsp.kicker": "Plan de protecție a mâinilor",
  "hsp.titleFallback": "Plan de protecție a pielii și a mâinilor",
  "hsp.loadError": "Planul de protecție a mâinilor nu a putut fi încărcat.",
  "hsp.empty": "Pentru această zonă de lucru nu există momentan un plan de protecție a mâinilor.",
  "hsp.plakatCreatingTitle": "Afișul se creează",
  "hsp.plakatCreatingText": "La prima accesare se generează imaginile — poate dura până la două minute. Apoi afișul este disponibil imediat.",
  "hsp.plakatFailedTitle": "Afișul nu a putut fi creat.",
  "hsp.plakatFailedHint": "Vă rugăm să încercați din nou. Vizualizarea text este disponibilă mai jos.",
  "hsp.plakatReload": "Afișul nu a putut fi încărcat acum. Vă rugăm să reîncărcați pagina.",
  "hsp.plakatTimeout": "Crearea durează mai mult decât era de așteptat. Încercați mai târziu.",
  "hsp.plakatRetry": "Afișul nu a putut fi creat. Vă rugăm să încercați din nou.",
  "hsp.plakatLoadFailed": "Afișul nu a putut fi încărcat acum.",
  "hsp.plakatImgError": "Imaginea afișului nu poate fi afișată.",
  "hsp.plakatAlt": "Afișul planului de protecție a mâinilor",
  "hsp.plakatLoadingAria": "Afișul se încarcă",
  "hsp.textOpen": "Afișează ca text",
  "hsp.textClose": "Închide vizualizarea text",
  "hsp.thWas": "Ce",
  "hsp.thWann": "Când",
  "hsp.thWomit": "Cu ce",
  "hsp.thWie": "Cum",
  "hsp.firstAidTitle": "Prim ajutor după contactul cu pielea",
  "hsp.gsvOne": "1 substanță periculoasă în această zonă",
  "hsp.gsvMany": "Substanțe periculoase în această zonă: {count}",
  "hsp.gsvMenge": "Cantitate în unitate:",
  "hsp.gsvHSaetze": "Fraze H:",
  "hsp.psaHandschutz": "Protecția mâinilor",
  "hsp.psaAtemschutz": "Protecție respiratorie",
  "hsp.psaAugenschutz": "Protecția ochilor",
  "hsp.psaKoerperschutz": "Protecția corpului",
  "hsp.psaErsteHilfe": "Prim ajutor după contactul cu pielea",
  "hsp.psaAetzReiz": "Efect coroziv/iritant",
  "hsp.psaSensibilisierung": "Sensibilizare",
  "hsp.psaPSaetze": "Fraze P",

  "fuehrerschein.title": "Verificarea permisului de conducere",
  "fuehrerschein.loadError": "Sarcina nu a putut fi încărcată.",
  "fuehrerschein.notApplicable": "Momentan nu este prevăzută o verificare a permisului pentru dumneavoastră.",
  "fuehrerschein.categoriesTitle": "Tipurile dumneavoastră de vehicule",
  "fuehrerschein.categoriesSubtitle": "Aceste tipuri de vehicule au fost stabilite pentru dumneavoastră de angajator.",
  "fuehrerschein.categoriesEmpty": "Nicio categorie atribuită.",
  "fuehrerschein.upToDateTitle": "Permis de conducere valabil",
  "fuehrerschein.upToDateText": "Momentan nu este necesară nicio verificare.",
  "fuehrerschein.nextDue": "Următoarea verificare până la",
  "fuehrerschein.lastDecision": "Ultima aprobare:",
  "fuehrerschein.submittedTitle": "Trimitere reușită",
  "fuehrerschein.submittedText": "Fotografia permisului și declarația sunt acum la angajator pentru verificare.",
  "fuehrerschein.submittedAt": "Trimis la",
  "fuehrerschein.declarationTitle": "Declarație",
  "fuehrerschein.declarationAccept": "Am citit declarația și o confirm.",
  "fuehrerschein.photoFrontTitle": "Fotografia permisului: față",
  "fuehrerschein.photoFrontHint": "Vă rugăm să fotografiați lizibil fața permisului (nume și data expirării vizibile).",
  "fuehrerschein.photoBackTitle": "Fotografia permisului: verso",
  "fuehrerschein.photoBackHint": "Vă rugăm să fotografiați lizibil versoul permisului (tabelul categoriilor vizibil).",
  "fuehrerschein.previewFrontAlt": "Previzualizare: fața permisului",
  "fuehrerschein.previewBackAlt": "Previzualizare: versoul permisului",
  "fuehrerschein.otherPhoto": "Altă fotografie",
  "fuehrerschein.remove": "Elimină",
  "fuehrerschein.pickFront": "Fotografiați fața sau alegeți un fișier",
  "fuehrerschein.pickBack": "Fotografiați versoul sau alegeți un fișier",
  "fuehrerschein.pickLimits": "Max. 12 MB · JPEG, PNG, WEBP, HEIC",
  "fuehrerschein.submit": "Trimite",
  "fuehrerschein.submitting": "Se trimite…",
  "fuehrerschein.submitSuccess": "Trimitere reușită.",
  "fuehrerschein.submitFailed": "Trimiterea a eșuat. Vă rugăm să încercați din nou.",
  "fuehrerschein.errFormat": "Format de imagine neacceptat. Alegeți JPEG, PNG, WEBP, HEIC sau HEIF.",
  "fuehrerschein.errSize": "Fișier prea mare. Maximum: 12 MB.",
  "fuehrerschein.ocrPreparing": "Se pregătește citirea automată…",
  "fuehrerschein.ocrUnavailable": "OCR temporar indisponibil — vă rugăm verificați permisul manual.",
  "fuehrerschein.ocrBannerStrong": "Transcriere automată",
  "fuehrerschein.ocrBannerRest": " — fără verificare de către CLartext, nu înlocuiește controlul vizual.",
  "fuehrerschein.ocrName": "Nume (citit)",
  "fuehrerschein.ocrExpiry": "Data expirării (citită)",
  "fuehrerschein.ocrClasses": "Categorii (citite)",
};
Object.assign(ro, roExtra);

export default ro;
